import { IS_SERVER } from '@af-app/config';
import CanvasWrapper from './CanvasWrapper';
import HeadlessCanvasWrapper from './HeadlessCanvasWrapper';

export default class CanvasWrapperFactory {
	public static create(width?: number, height?: number):CanvasWrapper {
		if(IS_SERVER) {
			return new HeadlessCanvasWrapper(width, height);
		} else {
			return new CanvasWrapper(width, height);
		}
	}
}